import { Carte } from './DossierCarte';
import { TuileChiffre, type Tuile } from '../../ui/TuileChiffre';
import type { ConvivesStats } from './useDossierConvives';

/**
 * « Suivi chiffré » (maquette 18a) : ce que le devis annonce, face à ce qui est réellement renseigné.
 * Les chiffres viennent de Menus & Convives (`useDossierConvives`) ; les couverts au devis, de la
 * privatisation créée. Sans privatisation, il n'y a encore rien à compter — on le dit plutôt que
 * d'aligner des tirets.
 */
export function SuiviChiffre({ couvertsDevis, stats }: { couvertsDevis?: number | null; stats: ConvivesStats | null }) {
    const tuiles: Tuile[] = [
        { label: 'Convives au devis', valeur: couvertsDevis || '—', ton: 'neutre' },
        { label: 'Invitations envoyées', valeur: stats ? stats.invites : '—', ton: 'info' },
        { label: 'Réponses reçues', valeur: stats ? stats.reponses : '—', unite: stats && stats.invites ? `sur ${stats.invites}` : undefined, ton: 'succes' },
        { label: 'Sans réponse', valeur: stats ? stats.silencieux : '—', ton: 'attention' },
        { label: 'Contraintes alimentaires', valeur: stats ? stats.contraintes : '—', ton: 'danger' },
    ];
    return (
        <Carte titre="Suivi chiffré" aside="Ce que le devis annonce, face à ce qui est réellement renseigné.">
            {stats ? (
                <div className="grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-2.5">
                    {tuiles.map((t) => <TuileChiffre key={t.label} t={t} />)}
                </div>
            ) : (
                <p className="text-[12px] text-content-muted">
                    Les chiffres arriveront avec la collecte des menus, une fois la privatisation créée et les convives importés.
                </p>
            )}
        </Carte>
    );
}
